import { useState } from "react";
import { cn } from "@/utils/cn";
import CompteSection from "./components/CompteSection";
import NotificationsSection from "./components/NotificationsSection";
import PreferencesSection from "./components/PreferencesSection";
import ProfilSection from "./components/ProfilSection";
import SecuriteSection from "./components/SecuriteSection";
import RolesPermissionsSection from "./components/RolesPermissionsSection";

type Onglet = "profil" | "roles" | "securite" | "notifications" | "preferences" | "compte";

const onglets: { id: Onglet; label: string; icon: string }[] = [
  { id: "profil", label: "Profil", icon: "ri-building-line" },
  { id: "roles", label: "Rôles et permissions", icon: "ri-shield-keyhole-line" },
  { id: "securite", label: "Sécurité", icon: "ri-lock-2-line" },
  { id: "notifications", label: "Notifications", icon: "ri-notification-3-line" },
  { id: "preferences", label: "Préférences", icon: "ri-equalizer-line" },
  { id: "compte", label: "Gestion du compte", icon: "ri-account-circle-line" },
];

export default function AgenceParametresPage() {
  const [onglet, setOnglet] = useState<Onglet>("profil");

  return (
    <div className="flex flex-col gap-6">
      <div className="max-w-2xl">
        <h2 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">Paramètres</h2>
        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
          Gérez le profil de l'agence, la sécurité du compte, les notifications, les préférences générales et les
          informations de votre compte.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[260px_1fr]">
        <nav className="flex flex-row gap-2 overflow-x-auto lg:flex-col lg:overflow-visible">
          {onglets.map((item) => {
            const active = onglet === item.id;
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => setOnglet(item.id)}
                className={cn(
                  "flex shrink-0 items-center gap-2.5 whitespace-nowrap rounded-md border px-3.5 py-2.5 text-sm font-label font-medium transition-colors cursor-pointer lg:w-full",
                  active
                    ? "border-primary-300 bg-primary-50 text-primary-900"
                    : "border-background-200 bg-background-50 text-foreground-700 hover:bg-background-100"
                )}
              >
                <span
                  className={cn(
                    "flex h-7 w-7 shrink-0 items-center justify-center rounded-md",
                    active ? "bg-primary-100 text-primary-700" : "bg-background-100 text-foreground-500"
                  )}
                >
                  <i className={cn(item.icon, "text-sm")} aria-hidden="true" />
                </span>
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="min-w-0">
          {onglet === "profil" && <ProfilSection />}
          {onglet === "roles" && <RolesPermissionsSection />}
          {onglet === "securite" && <SecuriteSection />}
          {onglet === "notifications" && <NotificationsSection />}
          {onglet === "preferences" && <PreferencesSection />}
          {onglet === "compte" && <CompteSection />}
        </div>
      </div>
    </div>
  );
}